import { callWithNuxt } from '#app';

export default defineNuxtPlugin((nuxtApp) => {
    const { token, signOut } = useAuth();

    const api = $fetch.create({
        onRequest({ request, options, error }) {
            if (token.value) {
                options.headers.set('Authorization', token.value);
            }
            if (options.body instanceof FormData) {
                // Remove the default 'Content-Type' header to let the browser set it correctly
                options.headers.delete('Content-Type');
            }
        },
        async onResponseError({ response }) {
            if (response.status === 401) {
                await nuxtApp.runWithContext(async () => await signOut({ callbackUrl: '/login', external: true }));
            }
        }
    });

    // Expose to useNuxtApp().$api
    return {
        provide: {
            api
        }
    };
});
